import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MultiSigningComponent} from './multisigning.component';
import { FormsModule }   from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
    imports: [CommonModule,FormsModule, SharedModule, PdfViewerModule],
    declarations: [MultiSigningComponent],
    exports: [MultiSigningComponent]
})

export class MultiSigningModule { }
